import { useEffect, useMemo } from 'preact/hooks';
import { serviceOptions } from '../../../functions/serviceOption';
export const useOptions = ({ watch, setValue }) => {
  const { province, provinceId, district, districtId, subDistrict } = watch();

  const provinceOptions = useMemo(() => serviceOptions('PROVINCE', province), [province]);

  const districtOptions = useMemo(
    () => (provinceId ? serviceOptions('DISTRICT', district) : []),
    [provinceId, district],
  );

  const subDistrictOptions = useMemo(
    () => (districtId ? serviceOptions('SUBDISTRICT', subDistrict) : []),
    [districtId, subDistrict],
  );

  useEffect(() => {
    if (provinceId) {
      const selectedDistrict = districtOptions[0];
      if (selectedDistrict) {
        setValue('districtId', selectedDistrict.value);
      }
    }
  }, [provinceId, districtOptions, setValue]);

  return {
    provinceOptions,
    districtOptions,
    subDistrictOptions,
  };
};
